import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Check, Crown, ShieldAlert } from "lucide-react";
import { http, useMeta } from "../lib/api";
import { useAuth } from "../lib/auth";
import PlanStatus from "../components/site/PlanStatus";
import PayButton from "../components/site/PayButton";
import ManualPay from "../components/site/ManualPay";
import { SITE } from "../lib/site";

const PERKS = ["Unlimited जाहिराती टाका", "सर्व विक्रेत्यांचे संपर्क पहा", "Call + WhatsApp थेट संपर्क", "संपूर्ण महाराष्ट्र - 36 जिल्हे"];

function PlanCard({ plan, enabled }) {
  const highlight = true;
  return (
    <div className={`relative rounded-2xl bg-white p-6 flex flex-col border-2 ${highlight ? "border-[var(--orange)] shadow-xl md:-translate-y-2" : "border-slate-200"}`} data-testid={`plan-card-${plan.id}`}>
      {plan.tag && <span className="absolute -top-3 left-6 px-3 py-0.5 rounded-full text-xs font-bold text-white bg-[var(--orange)]">फक्त ₹{plan.price} - संपूर्ण वर्ष!</span>}
      <p className="font-semibold text-slate-600">{plan.mr} · {plan.name}</p>
      <p className="mt-2 font-display font-extrabold text-4xl text-[var(--navy)]" data-testid={`plan-price-${plan.id}`}>₹{plan.price}</p>
      <p className="text-xs text-slate-500">{plan.days} दिवस · फक्त ₹{Math.ceil(plan.price / 12)}/महिना पेक्षा कमी</p>
      <ul className="mt-5 space-y-2 text-sm flex-1">
        {PERKS.map((p) => <li key={p} className="flex gap-2"><Check className="w-4 h-4 mt-0.5 text-green-600 shrink-0" /> {p}</li>)}
      </ul>
      <PayButton plan={plan} highlight={highlight} enabled={enabled} />
    </div>
  );
}

export default function Plans() {
  const meta = useMeta();
  const { user } = useAuth();
  const [enabled, setEnabled] = useState(false);
  useEffect(() => { http.get("/payments/status").then((r) => setEnabled(r.data.enabled)).catch(() => {}); }, []);
  return (
    <div className="max-w-5xl mx-auto px-4 py-10">
      <div className="text-center">
        <Crown className="w-10 h-10 mx-auto text-[var(--orange)]" />
        <h1 className="mt-2 font-display font-extrabold text-3xl md:text-4xl text-[var(--navy)]">Membership Plans</h1>
        <p className="mt-1 text-slate-600">नो ब्रोकर - नो कमिशन. फक्त छोटी Membership फी आणि थेट संपर्क.</p>
      </div>
      {meta?.free_mode && (
        <div className="mt-6 max-w-2xl mx-auto rounded-2xl bg-green-600 text-white p-5 text-center" data-testid="plans-free-mode">
          <p className="font-display font-extrabold text-2xl">सध्या 99Bazaar पूर्णपणे मोफत!</p>
          <p className="text-sm text-green-50 mt-1">जाहिरात टाकणे आणि संपर्क पाहणे - दोन्ही Free. फक्त मोबाईल नंबरने नोंदणी करा. Payment लवकरच सुरू होईल.</p>
          {!user && <Link to="/login" className="mt-3 inline-flex h-11 px-5 items-center rounded-xl bg-white text-green-700 font-bold" data-testid="plans-free-register">मोफत नोंदणी करा</Link>}
        </div>
      )}
      {user && !meta?.free_mode && <div className="mt-6 max-w-md mx-auto"><PlanStatus user={user} /></div>}
      <div className="mt-10 grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
        {meta?.plans.map((p) => <PlanCard key={p.id} plan={p} enabled={enabled} />)}
        {meta?.plans[0] && <ManualPay price={meta.plans[0].price} />}
      </div>
      <div className="mt-8 rounded-2xl bg-[#E3EEFC] border border-blue-100 p-5 text-sm text-[var(--navy)]" data-testid="plans-activation-note">
        <p className="font-semibold">एक प्लॅन, एक किंमत: ₹99 मध्ये 1 वर्ष Unlimited जाहिराती + सर्व संपर्क.</p>
        <p className="mt-1">Payment मध्ये अडचण? आम्हाला WhatsApp करा: <a href={`https://wa.me/${SITE.whatsapp}`} target="_blank" rel="noopener noreferrer" className="font-semibold text-[var(--buy)] underline" data-testid="plans-whatsapp-admin">{SITE.whatsappLabel}</a>. नवीन नोंदणीवर 3 दिवस Free Trial मिळतो. आधीचा प्लॅन सुरू असेल तर नवीन दिवस त्यात जोडले जातात.</p>
        {!user && <Link to="/login" className="mt-3 inline-block font-semibold text-[var(--sell)]" data-testid="plans-login-link">आधी नोंदणी करा →</Link>}
      </div>
      <p className="mt-6 text-xs text-slate-500 flex gap-2"><ShieldAlert className="w-4 h-4 shrink-0" /> 99Bazaar फक्त जाहिरात प्लॅटफॉर्म आहे. खरेदीदार व विक्रेता थेट व्यवहार करतात. Membership फी फक्त प्लॅटफॉर्म वापरासाठी आहे.</p>
    </div>
  );
}
